import { isEmpty } from 'lodash';
import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import {
    getFieldChangeItems,
    getProcessedFieldChangeItems,
    removePropertiesFromObject,
} from 'views/pages/admin/audit-log/service';
import { useTranslation } from '@hooks/index';

type RecordProps = {
    Association: number;
    AssociationRef?: string;
    ClosedDate?: Date;
    ClosedDatePopulatedOn?: Date;
    Comments?: string;
    DatasetOpenedOn: number;
    IsDeleted: boolean;
    IsSystemGenerated: boolean;
    Observation: string;
    ObservationDate: Date;
    Owner?: number;
    OwnerName?: string;
    PanelRef?: string;
    RootCause?: string;
    SiteCode?: string;
    SiteId?: number;
    SiteName?: string;
    Status: string;
    Type: number;
    PanelName?: string;
    AssociationName?: string;
    DataSetDate?: string;
};

type ObservationChangeGridProps = {
    oldRecord: Partial<RecordProps>;
    newRecord: Partial<RecordProps>;
    oldItem?: Record<string, unknown>;
    newItem?: Record<string, unknown>;
};

const CM2ObservationRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: ObservationChangeGridProps) => {
    const { t } = useTranslation();

    if (isEmpty(oldRecord) && isEmpty(newRecord)) return null;

    // Lots of ID fields to hide
    const propArray: string[] = [
        'AssociationRef',
        'OwnerId',
        'Owner',
        'IsDeleted',
        'IsSystemGenerated',
        'Site',
        'SiteCode',
        ...(newRecord.Type === 1 ? ['SiteId'] : []),
        'DatasetOpenedOn',
        'PanelRef',
        'Type',
        'ClosedDatePopulated',
        'ClosedDatePopulatedOn',
        'SiteId',
        'DataSetDate',
        'AssociationName',
        'PanelName',
        // Controls Hub observations don't have an Association
        ...(newRecord.Type === 2 ? ['Association'] : []),
    ];

    const refactoredOldRecord = {
        ...oldRecord,
        ...removePropertiesFromObject(oldRecord, propArray),
        Panel: oldRecord.PanelName,
        DatasetOpenedOn: oldRecord.DataSetDate,
        Type: !isEmpty(oldRecord) ? (oldRecord.IsSystemGenerated ? t('auditLog:system') : t('auditLog:manual')) : '',
    } as Record<string, unknown>;

    const refactoredNewRecord = {
        ...newRecord,
        ...removePropertiesFromObject(newRecord, propArray),
        Panel: newRecord.PanelName,
        DatasetOpenedOn: newRecord.DataSetDate,
        Type: !isEmpty(newRecord) ? (newRecord.IsSystemGenerated ? t('auditLog:system') : t('auditLog:manual')) : '',
    } as Record<string, unknown>;

    // Only Observations that aren't control hub have an Association
    if (newRecord.Type !== 2) {
        refactoredOldRecord.Association = oldRecord.AssociationName;
        refactoredNewRecord.Association = newRecord.AssociationName;
    }

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
        }),
    );

    return <FieldChangeGrid items={items} />;
};
export { CM2ObservationRecordChangeGrid };
